module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4GeGx"))).then(() => parcelRequire('ljYL6'));